<template>
  <section class="register">
    <div class="box" style="max-width: 500px">
      <div class="header">
        <div class="title">Solicitar Alteração</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent="sendMessage" class="form" style="padding: 0 15px">
        <textarea v-model="message" placeholder="Descreva que alterações devem ser realizadas" rows="10" :class="{ error : error.includes('message') }"></textarea>
        <div v-if="error.includes('message')" class="hint">Descrição não pode estar vazia</div>
        <div v-if="error.includes('internal')" class="hint">Ocorreu um erro ao enviar. Por favor tente novamente.</div>
        <div class="actions" style="padding: 15px 0">
          <button class="button-previous" style="visibility: hidden"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
          <button type="submit" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-paper-plane'"></i><span>Enviar</span></button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { businessUpdate } from '../api/mail'

export default {
  name: 'infoUpdate',
  props: ['close'],
  data () {
    return {
      error: [],
      loading: false,
      message: ''
    }
  },
  methods: {
    async sendMessage () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        await businessUpdate(this.message)
        this.close()
      } catch (error) {
        const data = error.response ? error.response.data : {}
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    }
  }
}
</script>
